import { MenuConfigModel } from '@core/models/outros/menu-config.model';
import { MENU_EXAMS } from './permissions/menu/menu-exams.constants';
import { MENU_FINANCIAL } from './permissions/menu/menu-financial.constants';
import { MENU_MANAGEMENT } from './permissions/menu/menu-management.constants';
import { MENU_PRACTICAL_COURSE } from './permissions/menu/menu-practical-course.constants';
import { MENU_REGISTER } from './permissions/menu/menu-register.constants';
import { MENU_THEORETICAL_COURSE } from './permissions/menu/menu-theoretical-course.constants';
import { MENU_USER_SETTINGS } from './permissions/menu/menu-user-settings.constants';
import { MENU_LOG } from './permissions/menu/menu-log.cosntants';
import { MENU_REPORTS } from './permissions/menu/menu-reports.constants';


export const menuConfig: MenuConfigModel[] = [
  MENU_REGISTER,
  MENU_PRACTICAL_COURSE,
  MENU_THEORETICAL_COURSE,
  MENU_EXAMS,
  MENU_FINANCIAL,
  MENU_MANAGEMENT,
  MENU_USER_SETTINGS,
  MENU_LOG,
  MENU_REPORTS,
];

